module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/binarysystem_wallpaper-c1e5105725a93f52c0231739d91aeab2.png";